import React from 'react';
import { motion } from 'framer-motion';
import {
  FaGraduationCap,
  FaHeart,
  FaHandsHelping,
  FaLeaf,
  FaHeartbeat
} from 'react-icons/fa';

const values = [
  {
    icon: <FaGraduationCap className="text-2xl" />,
    title: 'Education',
    description: 'Belief in education as the foundation for sustainable development.',
    color: 'from-cyan-500/10 to-blue-500/10',
    accent: 'from-cyan-400 to-blue-400',
    textColor: 'text-cyan-400'
  },
   {
    icon: <FaHeartbeat className="text-2xl" />,
    title: 'Health',
    description: 'Supporting community health, wellness and access to basic healthcare services.',
    color: 'from-rose-500/10 to-red-500/10',
    accent: 'from-rose-400 to-red-400',
    textColor: 'text-rose-400'
  },
  {
    icon: <FaHeart className="text-2xl" />,
    title: 'Compassion',
    description: 'Heart-centered approach to serving communities with empathy and understanding.',
    color: 'from-purple-500/10 to-pink-500/10',
    accent: 'from-purple-400 to-pink-400',
    textColor: 'text-purple-400'
  },
  {
    icon: <FaHandsHelping className="text-2xl" />,
    title: 'Community',
    description: 'Collaborative efforts that uplift and empower local communities.',
    color: 'from-blue-500/10 to-cyan-500/10',
    accent: 'from-blue-400 to-cyan-400',
    textColor: 'text-blue-400'
  },
  {
    icon: <FaLeaf className="text-2xl" />,
    title: 'Sustainability',
    description: 'Programs designed for long-term impact and environmental consciousness.',
    color: 'from-emerald-500/10 to-green-500/10',
    accent: 'from-emerald-400 to-green-400',
    textColor: 'text-emerald-400'
  }
  ,
 
];

const ValuesSection: React.FC = () => {
  return (
    <section className="py-12 px-4 md:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white">Our Core Values</h2>
        <p className="text-slate-200 max-w-2xl mx-auto mt-2">Principles that guide every decision and action we take.</p>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
        {values.map((v, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: i * 0.06 }}
            className="relative group"
          >
            <div className={`absolute -inset-2 rounded-2xl blur opacity-0 group-hover:opacity-80 transition-opacity duration-300 bg-gradient-to-r ${v.color}`} />
            <div className="relative bg-white/6 backdrop-blur-sm border border-white/10 p-6 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300">
              <div className={`inline-flex items-center justify-center w-12 h-12 rounded-lg mb-4 bg-gradient-to-r ${v.accent}`}>
                <div className="text-white">{v.icon}</div>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">{v.title}</h3>
              <p className="text-slate-200 text-sm">{v.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ValuesSection;
